import React from "react";
import { Typography, Alert, Box } from "@mui/material";
import AppModal from "../common/AppModal";
import AppButton from "../buttons/AppButton";
import SubmitButton from "../buttons/SubmitButton";

import FormAlert from "../common/FormAlert";

import { useAppDispatch } from "../../redux/store";
import { generateBatchReports } from "../../redux/actions/studentTermReportActions";
import { studentTermReportActions } from "../../redux/slices/studentTermReport";
import { StudentTermReportGenerationRequestDto } from "../../shared/dtos/studentTermReport/StudentTermReportGenerationRequestDto";

interface GenerateReportsModalProps {
  open: boolean;
  onClose: () => void;
  filters: { classroomId: string; termId: string };
  branchId?: string | null;
  loading: boolean;
  error: string | null;
}

const GenerateReportsModal: React.FC<GenerateReportsModalProps> = ({
  open,
  onClose,
  filters,
  branchId,
  loading,
  error,
}) => {
  const dispatch = useAppDispatch();

  const handleConfirm = (): void => {
    if (!filters.classroomId || !filters.termId || !branchId) return;

    const payload: StudentTermReportGenerationRequestDto = {
      classroomId: filters.classroomId,
      termId: filters.termId,
      branchId,
    };
    dispatch(generateBatchReports(payload));
  };

  return (
    <AppModal
      open={open}
      onClose={onClose}
      title="Generate Term Reports"
      width="sm"
      loading={loading}
    >
      <Box sx={{ width: "100%" }}>
        <Typography variant="body1" sx={{ mb: 2 }}>
          You are about to generate academic reports for all students in the
          selected classroom.
        </Typography>

        <FormAlert
          message={error}
          severity="error"
          closable
          onClose={() =>
            dispatch(studentTermReportActions.setErrorGenerating(null))
          }
        />

        <Alert severity="warning" sx={{ mb: 3, textAlign: "left" }}>
          This will recalculate all subject scores and re-assign class
          positions. Existing reports will be updated.
        </Alert>

        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
          <AppButton
            fullWidth
            onClick={onClose}
            color="inherit"
            disabled={loading}
          >
            Cancel
          </AppButton>
          <SubmitButton
            title="Start Generation"
            loadingText="Processing..."
            loading={loading}
            color="secondary"
            onClick={handleConfirm}
            disabled={loading}
          />
        </Box>
      </Box>
    </AppModal>
  );
};

export default GenerateReportsModal;
